
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Megaphone, Plus, Heart, MessageCircle, Share2, Camera, Video, Music, Tag } from "lucide-react";

const VenuePromotions = () => {
  const posts = [
    {
      id: 1,
      content: "🎉 Saturday Night Groove with DJ Maphorisa! Limited tickets available. Book now! 🎵",
      media: "image",
      likes: 342,
      comments: 67,
      shares: 28,
      timestamp: "2 hours ago",
      tagged: ["DJ Maphorisa"],
      status: "published"
    },
    {
      id: 2,
      content: "Behind the scenes from last weekend's epic Amapiano night! The energy was incredible! 🔥",
      media: "video",
      likes: 189,
      comments: 23,
      shares: 15,
      timestamp: "1 day ago",
      tagged: ["MC Thabo"],
      status: "published"
    }
  ];

  return (
    <div className="space-y-6">
      <Card className="bg-white/5 border-white/20 backdrop-blur-sm">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-white flex items-center gap-2">
              <Megaphone className="w-5 h-5" />
              Promotions & Content
            </CardTitle>
            <Button className="bg-white text-black hover:bg-gray-200">
              <Plus className="w-4 h-4 mr-2" />
              Create Post
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Create New Post */}
          <Card className="bg-white/5 border-white/20">
            <CardHeader>
              <CardTitle className="text-white text-lg">Create Promotional Post</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <label className="text-white text-sm font-medium mb-2 block">Post Content</label>
                <textarea
                  placeholder="What's happening at your venue? Share updates, events, highlights..."
                  className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white placeholder-gray-400 h-24"
                />
              </div>
              
              <div className="flex items-center gap-4">
                <Button variant="outline" size="sm" className="border-white text-white hover:bg-white hover:text-black">
                  <Camera className="w-4 h-4 mr-2" />
                  Photo
                </Button>
                <Button variant="outline" size="sm" className="border-white text-white hover:bg-white hover:text-black">
                  <Video className="w-4 h-4 mr-2" />
                  Video
                </Button>
                <Button variant="outline" size="sm" className="border-white text-white hover:bg-white hover:text-black">
                  <Music className="w-4 h-4 mr-2" />
                  Audio
                </Button>
                <Button variant="outline" size="sm" className="border-white text-white hover:bg-white hover:text-black">
                  <Tag className="w-4 h-4 mr-2" />
                  Tag Creator
                </Button>
              </div>
              
              <div>
                <label className="text-white text-sm font-medium mb-2 block">Tag Creators/Events</label>
                <input
                  type="text"
                  placeholder="Start typing to search creators or events..."
                  className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white placeholder-gray-400"
                />
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <label className="flex items-center gap-2 text-gray-400 text-sm">
                    <input type="checkbox" className="rounded" />
                    Schedule for later
                  </label>
                  <label className="flex items-center gap-2 text-gray-400 text-sm">
                    <input type="checkbox" className="rounded" />
                    Boost post
                  </label>
                </div>
                <Button className="bg-white text-black hover:bg-gray-200">
                  Post Now
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Previous Posts */}
          <div className="space-y-4">
            <h3 className="text-white font-medium text-lg">Recent Posts</h3>
            {posts.map((post) => (
              <Card key={post.id} className="bg-white/5 border-white/20">
                <CardContent className="p-6">
                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center">
                          <Megaphone className="w-5 h-5 text-white" />
                        </div>
                        <div>
                          <div className="text-white font-medium">Club Babylon</div>
                          <div className="text-gray-400 text-sm">{post.timestamp}</div>
                        </div>
                      </div>
                      <Badge className="bg-green-500/20 text-green-400">{post.status}</Badge>
                    </div>
                    
                    <p className="text-white">{post.content}</p>
                    
                    {post.tagged.length > 0 && (
                      <div className="flex items-center gap-2">
                        <Tag className="w-4 h-4 text-gray-400" />
                        <span className="text-gray-400 text-sm">Tagged:</span>
                        {post.tagged.map((tag, index) => (
                          <Badge key={index} variant="outline" className="border-blue-400 text-blue-400">
                            {tag}
                          </Badge>
                        ))}
                      </div>
                    )}
                    
                    {/* Media placeholder */}
                    <div className="bg-white/10 rounded-lg h-48 flex items-center justify-center">
                      {post.media === 'image' && <Camera className="w-12 h-12 text-white/50" />}
                      {post.media === 'video' && <Video className="w-12 h-12 text-white/50" />}
                    </div>
                    
                    <div className="flex items-center justify-between pt-4 border-t border-white/10">
                      <div className="flex items-center space-x-6">
                        <Button variant="ghost" size="sm" className="text-gray-400 hover:text-white hover:bg-white/10">
                          <Heart className="w-4 h-4 mr-2" />
                          {post.likes}
                        </Button>
                        <Button variant="ghost" size="sm" className="text-gray-400 hover:text-white hover:bg-white/10">
                          <MessageCircle className="w-4 h-4 mr-2" />
                          {post.comments}
                        </Button>
                        <Button variant="ghost" size="sm" className="text-gray-400 hover:text-white hover:bg-white/10">
                          <Share2 className="w-4 h-4 mr-2" />
                          {post.shares}
                        </Button>
                      </div>
                      <div className="flex gap-2">
                        <Button size="sm" variant="outline" className="border-white text-white hover:bg-white hover:text-black">
                          Edit
                        </Button>
                        <Button size="sm" variant="outline" className="border-white text-white hover:bg-white hover:text-black">
                          Boost
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Content Calendar */}
          <Card className="bg-white/5 border-white/20">
            <CardHeader>
              <CardTitle className="text-white text-lg">Content Calendar</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-7 gap-2">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
                  <div key={day} className="text-center">
                    <div className="text-white font-medium mb-2">{day}</div>
                    <div className="space-y-1">
                      {day === 'Fri' && (
                        <div className="bg-blue-500/20 text-blue-400 text-xs p-1 rounded">
                          Event Post
                        </div>
                      )}
                      {day === 'Sat' && (
                        <div className="bg-green-500/20 text-green-400 text-xs p-1 rounded">
                          Live Updates
                        </div>
                      )}
                      {day === 'Sun' && (
                        <div className="bg-purple-500/20 text-purple-400 text-xs p-1 rounded">
                          Highlights
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </div>
  );
};

export default VenuePromotions;
